import React, {useState} from 'react';
import "./TopBar.sass";
import {useGlobal} from "reactn";
import {useSelector} from "react-redux";
import {Image} from "react-bootstrap";
import facebookIcon from "../../../assets/facebook.png";
import zaloIcon from "../../../assets/zalo.png";
import zaloPersonalIcon from "../../../assets/zalo-personal.png";
import clientChatIcon from "../../../assets/chat-client.svg";
import homeIcon from "../../../assets/chat-all.svg";
import { Tooltip } from 'antd'

const TopBar = ({setDisableLoadMore}) => {
    const [socialActive, setSocialActive] = useGlobal('socialActive');
    const setPageCurrentRoom = useGlobal('pageCurrentRoom')[1];
    const notificationsUser = useSelector(state => state.io.notificationsUser);

    //Filter
    const [roomFilter, setRoomFilter] = useGlobal('roomFilter');
    const Setting = useGlobal('settings')[0];

    const handleSetChatType = (social = '') => {
        setDisableLoadMore(false);
        setPageCurrentRoom(1);
        setSocialActive(social); // Set type social active
        localStorage.setItem("active_source", social);
        setRoomFilter({...roomFilter, channel_id: '', source: social});
    }

    return (
        <div className="nav-bar uk-flex">
            <div className="topbar-left">
                <div className={`item${!socialActive ? ' active' : ''}`} onClick={() => handleSetChatType()}>
                    <Tooltip placement="bottom" title={`Tất cả`}>
                        <div className="icon">
                            <Image width="40" style={{ padding: "5px" }} src={homeIcon}/>
                            {(notificationsUser && notificationsUser.total > 0) && (
                                <span className="nav-noti nav-chat-noti">{notificationsUser.total > 99 ? '99+' : notificationsUser.total}</span>
                            )}
                        </div>
                    </Tooltip>
                </div>
                <div className={`item${socialActive === 'client' ? ' active' : ''}`} onClick={() => handleSetChatType('client')}>
                    <Tooltip placement="bottom" title={`Livechat`}>
                        <div className="icon">
                            <Image width="37" src={clientChatIcon}/>
                            {(notificationsUser && notificationsUser.client > 0) && (
                                <span className="nav-noti nav-chat-noti">{notificationsUser.client > 99 ? '99+' : notificationsUser.client}</span>
                            )}
                        </div>
                    </Tooltip>
                </div>
                <div className={`item${socialActive === 'facebook' ? ' active' : ''}`} onClick={() => handleSetChatType('facebook')}>
                    <Tooltip placement="bottom" title={`Messenger`}>
                        <div className="icon">
                            <Image width="40" src={facebookIcon}/>
                            {(notificationsUser && notificationsUser.facebook > 0) && (
                                <span className="nav-noti nav-chat-noti noti-social">{notificationsUser.facebook > 99 ? '99+' : notificationsUser.facebook}</span>
                            )}
                        </div>
                    </Tooltip>
                </div>
                <div className={`item${socialActive === 'zalo' ? ' active' : ''}`} onClick={() => handleSetChatType('zalo')}>
                    <Tooltip placement="bottom" title={`Zalo OA`}>
                        <div className="icon">
                            <Image width="40" src={zaloIcon}/>
                            {(notificationsUser && notificationsUser.zalo > 0) && (
                                <span className="nav-noti nav-chat-noti noti-social">{notificationsUser.zalo > 99 ? '99+' : notificationsUser.zalo}</span>
                            )}
                        </div>
                    </Tooltip>
                </div>
                {(Setting && Setting.enable_zalo_personal === 1) && (
                    <div className={`item${socialActive === 'zalo_personal' ? ' active' : ''}`} onClick={() => handleSetChatType('zalo_personal')}>
                        <Tooltip placement="bottom" title={`Zalo cá nhân`}>
                            <div className="icon">
                                <Image width="40" src={zaloPersonalIcon}/>
                                {(notificationsUser && notificationsUser.zalo_personal > 0) && (
                                    <span className="nav-noti nav-chat-noti noti-social">{notificationsUser.zalo_personal > 99 ? '99+' : notificationsUser.zalo_personal}</span>
                                )}

                            </div>
                        </Tooltip>
                    </div>
                )}
            </div>
            <div className="topbar-right text-right mt-2 cursor-pointer d-flex justify-content-end"></div>
        </div>
    );
}

export default TopBar;
